import { baseApi } from "@/config/http-common";

class CompanyDataService {
  getAll(params?: Record<string, unknown>): Promise<any> {
    return baseApi.get("/users/companies/list", { params });
  }

  get(id: any): Promise<any> {
    return baseApi.get(`/users/companies/view/${id}`);
  }

  create(data: any): Promise<any> {
    return baseApi.post("/users/companies/create", data);
  }

  update(id: any, data: any): Promise<any> {
    return baseApi.put(`/users/companies/update/${id}`, data);
  }

  delete(id: string, coordinatorId?: string): Promise<any> {
    return baseApi.delete(`/users/companies/delete/${id}`, {
      params: coordinatorId != null ? { coordinatorId } : undefined,
    });
  }

  getParents(): Promise<any> {
    return baseApi.get("/users/companies/parents/list");
  }
}

export default new CompanyDataService();
